import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	inviteFormTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inviteHelperMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inviteButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	inviteFormTitle: {
		id: 'horizontal-nav-header.common.invite-button.invite-form-title',
		defaultMessage: 'Invite',
		description: 'Title of a form to invite users to the project or board',
	},
	inviteHelperMessage: {
		id: 'horizontal-nav-header.common.invite-button.invite-helper-message',
		defaultMessage: 'This view, along with any applied groups and filters are shared',
		description:
			'Message indicating the recipients of the email invite will be able to see other tab views as well',
	},
	inviteButtonLabel: {
		id: 'horizontal-nav-header.common.invite-button.label',
		defaultMessage: 'Invite',
		description: 'Label for the invite button',
	},
});
export default messages;
